module.exports = __webpack_public_path__ + "media/flags/cu-0cd43a07.svg";